export default __webpack_public_path__ + "static/media/calendar.aac1dc83.svg";